<template>
  <div class="gd-searh__input-wrap">
    <div class="gd-searh__input-wrap-inner">
      <input
        ref="search"
        type="text"
        class="gd-searh__input"
        placeholder="Search by address, suburb..."
      />
      <button v-if="loading" class="gd-searh__btn">
        <div class="loader"></div>
      </button>
    </div>
    <div @click="setfilterOpen()" class="gd-searh__btn gd-searh__btn--filter">
      <svg>
        <use xlink:href="#sliders-h-regular"></use>
      </svg>
      <div class="gd-searh__num">{{ selected }}</div>
    </div>
    <transition name="slide-up-fade" mode="out-in">
      <MobFilters v-if="filterOpen" @close="setfilterOpen()" />
    </transition>
    <Filters />
    <div ref="info" class="d-none"></div>
  </div>
</template>
<script>
import Filters from "./Filters.vue";
import MobFilters from "./MobFilters.vue";
import getCategory from "../../mixins/getCategory";
export default {
  name: "GoogleSearch",
  mixins: [getCategory],
  components: {
    Filters,
    MobFilters,
  },
};
</script>